module.exports = __webpack_public_path__ + "static/media/cloudware-logo.7b6131f3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloudware-logo.webp
// module id = 633
// module chunks = 0